export default __webpack_public_path__ + "static/media/the-right-mix-img.92028841.png";